export default __webpack_public_path__ + "img/UbVSNOfh.2dc5a854.svg";